import { BaseApi } from './base.apis'

export class RiskGradingsApi extends BaseApi {}

export const riskGradingsApi = new RiskGradingsApi('/admin/riskGradings')
